export const SPANISH_DATE_FORMAT = {
  year: "numeric",
  month: "long",
  day: "numeric",
};

export const MESSENGER_DETAILS_KEYS = ["nm", "rat", "br", "msty"];
export const COLLECTION_KEYS = ["amtCol", "amtDep", "amtTra", "amtCash", "amtTransfer", "amtDeposit", "amtAECash", "amtLECash", "amtCECash", "amtEmiCash", "amtDpCash"];
export const VERIFICATION_TABLE_CONSTANTS = ["id", "ts", "amt", "st"];
